// For declaring AB test constants
// e.g.
// export const RECURRING_PAYMENT_PORTAL = 'Recurring Payment Portal';
// export const RECURRING_PAYMENT_PORTAL_DISABLED = 'Disabled';
// export const RECURRING_PAYMENT_PORTAL_ENABLED = 'Enabled';
// export const RECURRING_PAYMENT_PORTAL_RATIOS = [0, 100];

export const DISABLED_VARIANT = 'Disabled';
export const ENABLED_VARIANT = 'Enabled';

// Test setup for providing inbound phone lines for customers during payment
// setup. PAYROLL_PHONE_HELP is the experiment for Verified users and
// UNVERIFIED_PAYROLL_PHONE_HELP is for unverified users. The UX is the same
// for both groups

export const PAYROLL_PHONE_HELP = 'Payroll Phone Help';
export const PAYROLL_PHONE_HELP_RATIOS = [0, 100]; // [percent of new users disabled, percent of new users enabled]

export const UNVERIFIED_PAYROLL_PHONE_HELP = 'Unverified Payroll Phone Help';
export const UNVERIFIED_PAYROLL_PHONE_HELP_RATIOS = [50, 50];

// Backend AB Tests
// example:
//
// const PINWHEEL_FOR_UNVERIFIED_EXPERIMENT_NAME = 'Pinwheel For Unverified';
// const PINWHEEL_FOR_UNVERIFIED_STORE_NAME = 'pinwheelForUnverified';
// export const PINWHEEL_FOR_UNVERIFIED_API_NAME = 'pinwheel_for_unverified';
//
// export const backendABTestMap = {
//     [PINWHEEL_FOR_UNVERIFIED_STORE_NAME]: PINWHEEL_FOR_UNVERIFIED_EXPERIMENT_NAME,
// };
const DASHBOARD_REDESIGN_EXPERIMENT_NAME = 'Dashboard Redesign';
const DASHBOARD_REDESIGN_STORE_NAME = 'dashboardV2';

const METAL_CARD_EXPERIMENT_NAME = 'Metal Card';
export const METAL_CARD_STORE_NAME = 'metalCard';
export const METAL_CARD_API_NAME = 'metal_card';

const EARLY_INSTANT_SHIP_MOTIVATOR_EXPERIMENT_NAME =
    'Early Instant Ship Motivator';
export const EARLY_INSTANT_SHIP_MOTIVATOR_STORE_NAME =
    'earlyInstantShipMotivatorTest';
export const EARLY_INSTANT_SHIP_MOTIVATOR_API_NAME =
    'early_instant_ship_motivator_test';

const SPENDING_LIMIT_LOYALTY_UI = 'Spending Limit Loyalty UI';
export const SPENDING_LIMIT_LOYALTY_UI_STORE_NAME = 'mkpFtbLoyalty';
export const SPENDING_LIMIT_LOYALTY_UI_API_NAME = 'mkp_ftb_loyalty';

const REMOVE_PDP_TESTIMONIAL_TEST_NAME = 'Remove PDP Testimonial Test';
export const REMOVE_PDP_TESTIMONIAL_TEST_STORE_NAME =
    'removePdpTestimonialTest';
export const REMOVE_PDP_TESTIMONIAL_TEST_API_NAME =
    'remove_pdp_testimonial_test';

const VIRTUAL_PROVISIONING = 'Web Push Provisioning';
export const VIRTUAL_PROVISIONING_STORE_NAME = 'webPushProvisioningTest';
export const VIRTUAL_PROVISIONING_API_NAME = 'web_push_provisioning_test';

const PRODUCT_CAROUSELS_TEST_NAME = 'Product Carousels Test';
export const PRODUCT_CAROUSELS_TEST_STORE_NAME = 'productCarouselsTest';
export const PRODUCT_CAROUSELS_TEST_API_NAME = 'product_carousels_test';

const STOREFRONT_APP_DOWNLOAD_MOTIVATOR_TEST_NAME =
    'Storefront App Download Motivator';
export const STOREFRONT_APP_DOWNLOAD_MOTIVATOR_STORE_NAME =
    'storefrontAppDownloadMotivator';
export const STOREFRONT_APP_DOWNLOAD_MOTIVATOR_API_NAME =
    'storefront_app_download_motivator';

const CARD_FREEZE_TEST_NAME = 'Card Freeze';
export const CARD_FREEZE_STORE_NAME = 'cardFreeze';
export const CARD_FREEZE_API_NAME = 'card_freeze';

const SOLO_IN_MARKETPLACE_PHO_TEST_NAME = 'Solo In Marketplace PHO Test';
export const SOLO_IN_MARKETPLACE_PHO_TEST_STORE_NAME = 'soloInMarketplacePho';
export const SOLO_IN_MARKETPLACE_PHO_TEST_API_NAME = 'solo_in_marketplace_pho';

const UPDATED_WITHDRAWAL_FLOW_TEST_NAME = 'Withdrawal Flow with JPM Test';
export const UPDATED_WITHDRAWAL_TEST_STORE_NAME = 'ssWithdrawalJpm';
export const UPDATED_WITHDRAWAL_TEST_API_NAME = 'ss_withdrawal_jpm';

export const backendABTestMap = {
    [DASHBOARD_REDESIGN_STORE_NAME]: DASHBOARD_REDESIGN_EXPERIMENT_NAME,
    [EARLY_INSTANT_SHIP_MOTIVATOR_STORE_NAME]:
        EARLY_INSTANT_SHIP_MOTIVATOR_EXPERIMENT_NAME,
    [METAL_CARD_STORE_NAME]: METAL_CARD_EXPERIMENT_NAME,
    [SPENDING_LIMIT_LOYALTY_UI_STORE_NAME]: SPENDING_LIMIT_LOYALTY_UI,
    [REMOVE_PDP_TESTIMONIAL_TEST_STORE_NAME]: REMOVE_PDP_TESTIMONIAL_TEST_NAME,
    [VIRTUAL_PROVISIONING_STORE_NAME]: VIRTUAL_PROVISIONING,
    [PRODUCT_CAROUSELS_TEST_STORE_NAME]: PRODUCT_CAROUSELS_TEST_NAME,
    [STOREFRONT_APP_DOWNLOAD_MOTIVATOR_STORE_NAME]:
        STOREFRONT_APP_DOWNLOAD_MOTIVATOR_TEST_NAME,
    [CARD_FREEZE_STORE_NAME]: CARD_FREEZE_TEST_NAME,
    [SOLO_IN_MARKETPLACE_PHO_TEST_STORE_NAME]:
        SOLO_IN_MARKETPLACE_PHO_TEST_NAME,
    [UPDATED_WITHDRAWAL_TEST_STORE_NAME]: UPDATED_WITHDRAWAL_FLOW_TEST_NAME,
};
